import React, {useEffect, useRef, useState} from 'react'
import Stack from '@mui/material/Stack';

import Item from './Item.js';
import { useSelector } from 'react-redux';
import { Box, Button, TextField } from '@mui/material';

const SelectComment = ({onSelect, selected, activeState}) => {

    const [comment, setComment] = useState(activeState.comment)
    const [title, setTitle] = useState(activeState.title)

    useEffect(() => {
        if(activeState.reason === 'end'){
            onChangeTitle({target : {value : 'Fin du match'}})
        }
    }, [])

    const onChangeComment = (e) => {
        setComment(e.target.value)
    }

    const onChangeTitle = (e) => {
        setTitle(e.target.value)
        activeState.title=e.target.value
    }

    return (
        <Box sx={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
        <TextField sx={{width : '80%', color : 'white'}}
            placeholder="Votre titre ici ..."
            value={title}
            inputProps={{ style: { color: 'white' } }}
            fullWidth
            multiline
            onInput={onChangeTitle}
        />

        <TextField sx={{width : '80%', mt : 2}}
            placeholder="Votre commentaire ici ..."
            value={comment}
            inputProps={{ style: { color: 'white' } }}
            fullWidth
            multiline
            onInput={onChangeComment}
        />
        <Button sx={{width : '30%', mt : 2}}
        variant="contained" 
        onClick={() => onSelect(comment)}>Confirmer</Button>
        </Box>
    )
}

export default SelectComment